import { render, staticRenderFns } from "./FeaturedCategories.vue?vue&type=template&id=2dcb1992&scoped=true&lang=pug&"
import script from "./FeaturedCategories.vue?vue&type=script&lang=js&"
export * from "./FeaturedCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcb1992",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dcb1992')) {
      api.createRecord('2dcb1992', component.options)
    } else {
      api.reload('2dcb1992', component.options)
    }
    module.hot.accept("./FeaturedCategories.vue?vue&type=template&id=2dcb1992&scoped=true&lang=pug&", function () {
      api.rerender('2dcb1992', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/sections/FeaturedCategories.vue"
export default component.exports